import { render, staticRenderFns } from "./visit-sidebar.vue?vue&type=template&id=4c549ac2"
import script from "./visit-sidebar.vue?vue&type=script&lang=js"
export * from "./visit-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports